import MainLineSvgStyled from './style';

const MainLineSvg = ({ viewport }) => {
  return (
    <MainLineSvgStyled viewBox="335 285 1250 400" viewport={viewport}>
      <path
        d="M636,489.5c7.83,0,15.74-0.68,23.48,0.15c13.99,1.5,27.68,2.51,40.02-6.15l1.5-1
	c6.96-2.84,10.99-7.48,9.23-15.81c-0.7-0.56-1.6-1.67-2.75-2.13c-4.09-1.63-8.77,0.09-8.89,3.45c-0.2,5.59-0.78,11.22,2.32,16.55
	c2.88,4.94,6.13,9.18,12.1,9.87c4.79,0.55,9.66,0.44,14.49,0.57c9.16,0.26,16.46-3.24,21.46-10.55L750,483
	c2.17-3.17,4.78-6.13,6.37-9.56c1.56-3.36,2.28-7.21-1.07-10.64c-4.25-1.35-7.34,0.7-8.15,4.73c-0.99,4.91-2.07,10.14,0.84,14.97
	l1.17,1.64c7.38,4.87,15.65,5.93,23.84,6.25c18.67,0.74,37.07-1.87,55.53-4.68c21.36-3.25,42.95-5.05,64.47-7.14
	c10.96-1.07,21.99-1.45,32.99-2.06c13.16-0.72,26.33-1.39,39.5-2c9.16-0.42,18.33-0.64,27.5-1.03c6-0.26,12-0.65,18-0.98
	c12.17-0.67,24.35-1.17,36.49-2.07c5.53-0.41,11.12-1.15,16.48-2.54c6.29-1.64,12.55-3.05,19.02-2.33
	c5.43,0.6,11.01,1.15,15.01,5.69l3.5-0.25c7.78,3.32,6.62,4.59,7.23,7.25c1.07,8.2-2.65,13.91-9.23,17.75
	c-4.82,2.82-11.23-0.41-10.87-5.99c0.5-7.73,3.28-14.35,10.38-18.66l1.99-0.6c7.28-9.6,18.36-11.98,29.04-14.61
	c8.32-2.05,16.92-3.34,25.48-4.01c10.27-0.8,20.25,0.74,28.48,7.87c5.46,4.72,8.4,10.17,1.94,18.94
	c-3.83,5.2-8.11,10.23-15.43,10.55c-4.22,0.18-8.45-0.19-10.41-4.54c-1.8-4-0.48-8.45,2.07-11.32c5.15-5.79,11.18-10.8,16.85-16.14
	l2-0.5c0.83-0.83,1.52-2.04,2.52-2.44c9.46-3.76,18.82-7.88,28.53-10.9c7.42-2.3,15.25-3.39,22.96-4.6
	c9.13-1.43,18.33-2.38,27.49-3.56c5-0.64,9.98-1.53,15-1.95c6.48-0.54,13-0.72,19.5-1.05"
      />
    </MainLineSvgStyled>
  );
};

export default MainLineSvg;
